import getIntl from 'Helpers/intl'
import { pageState } from '../states/page'
import { logAppError } from 'Helpers/logger'
import {
  progressState,
  recipientsState,
  scheduledSendingState
} from '../states/state'
import {
  createSendingQueue,
  getFilters,
  getMessage,
  getQueuings,
  getSmsCredits,
  getSmsListSubscriptionCounters,
  lazySearchForRecipients,
  patchSchedule
} from '../actions/actions'

import {
  PROGRESSBAR_VARIANT_DEFAULT,
  PROGRESSBAR_VARIANT_SUCCESS,
  PROGRESSBAR_VARIANT_ERROR,
  toastShow,
  TOAST_VARIANT_WARNING,
  TOAST_VARIANT_ERROR
} from 'mailup-web-components'
import {
  BERCS_SENDING_STATE_COMPLETED,
  BERCS_SENDING_STATE_FALIED,
  BERCS_SENDING_STATE_RUNNING,
  BERCS_SENDING_STATE_TOECEXUTE,
  RCS_QUEUING_COMPLETED,
  RCS_QUEUING_FAILED,
  RCS_QUEUING_RUNNING
} from 'Api/beRcs'
import {
  searchCriteriaOptionsState,
  searchCriteriaState
} from '../states/searchCriteria'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'

export const resetCallback = ({ set, reset }) => async id => {
  reset(pageState)
  reset(searchCriteriaState)
  reset(progressState)
  reset(recipientsState)
}

export const initCallback = ({ set, snapshot }) => async idMessage => {
  set(pageState, prev => ({
    ...prev,
    load: true
  }))
  try {
    const [messageDetails, subscriptionCounters] = await Promise.all([
      getMessage(idMessage),
      getSmsListSubscriptionCounters()
    ])

    set(pageState, prev => ({
      ...prev,
      messageName: messageDetails ? messageDetails.Name : ''
    }))

    set(recipientsState, prev => ({
      ...prev,
      totalRecipients: subscriptionCounters.OptInCount
    }))
  } catch (error) {
    logAppError({ appError: error })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({
    ...prev,
    load: false
  }))
}

export const initSearchCriteriaCallback = ({ set, snapshot }) => async () => {
  set(searchCriteriaState, prev => ({ ...prev, loading: true }))

  try {
    const filters = await getFilters()

    set(searchCriteriaOptionsState, prev => ({
      ...prev,
      filters
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'RCSSendingWizard',
      Method: 'searchCriteriaCallback',
      Message: 'Errore in ottieni criteri di ricerca'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(searchCriteriaState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const countFilterRecipientsCallback = ({
  set,
  snapshot
}) => async () => {
  set(recipientsState, prev => ({
    ...prev,
    loadingRecipients: true
  }))
  set(searchCriteriaState, prev => ({
    ...prev,
    isNewSerach: false
  }))
  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = await snapshot.getPromise(searchCriteriaState)
  try {
    const ret = await lazySearchForRecipients(
      {
        channel: 'Sms',
        pageSize: 1,
        pageNumber: 1,
        status: 'Subscribed'
      },
      {
        IncludeGroups: includeGroups,
        ExcludeGroups: excludeGroups,
        MatchingFilters: {
          Condition: typeAppliedFilters,
          Filters: selectedFilters
        }
      }
    )

    set(recipientsState, prev => ({
      ...prev,
      filetrRecipients: ret.TotalItems
    }))

    if (ret.TotalItems === 0) {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.RecipientsSelectionWarningToastZeroRecipients'
        }),
        TOAST_VARIANT_WARNING,
        'RecipientsSelectionWarningToastZeroRecipients'
      )
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'RCSSendingWizard',
      Method: 'countFilterRecipientsCallback',
      Message: 'Errore countFilterRecipientsCallback'
    })
  }
  set(recipientsState, prev => ({
    ...prev,
    loadingRecipients: false
  }))
}

export const checkRecipientsCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = await snapshot.getPromise(searchCriteriaState)
  const { recipients } = await snapshot.getPromise(pageState)
  try {
    set(searchCriteriaState, prev => ({
      ...prev,
      isNewSerach: false
    }))
    const params =
      recipients === 'All'
        ? {}
        : {
            IncludeGroups: includeGroups,
            ExcludeGroups: excludeGroups,
            MatchingFilters: {
              Condition: typeAppliedFilters,
              Filters: selectedFilters
            }
          }
    const ret = await lazySearchForRecipients(
      {
        channel: 'Sms',
        pageSize: 1,
        pageNumber: 1,
        status: 'Subscribed'
      },
      params
    )
    set(recipientsState, prev => ({
      ...prev,
      filetrRecipients: ret.TotalItems
    }))
    if (ret.TotalItems > 0) {
      set(pageState, prev => ({
        ...prev,
        wizardStep: 2,
        numberOfStepEnabled: 2
      }))
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.RecipientsSelectionWarningToastZeroRecipients'
        }),
        TOAST_VARIANT_WARNING,
        'RecipientsSelectionWarningToastZeroRecipients'
      )
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'RCSSendingWizard',
      Method: 'countFilterRecipientsCallback',
      Message: 'Errore countFilterRecipientsCallback'
    })
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const checkProgressCallback = ({ set, snapshot }) => async () => {
  try {
    const { idQueuing, totalCredits } = await snapshot.getPromise(pageState)
    const { Queued, ToBeQueued, Cost, State } = await getQueuings(idQueuing)
    let queuedPercentage = 0
    let queueStatus
    let variant = PROGRESSBAR_VARIANT_DEFAULT

    if (
      State === BERCS_SENDING_STATE_TOECEXUTE ||
      State === BERCS_SENDING_STATE_RUNNING
    ) {
      queueStatus = RCS_QUEUING_RUNNING

      if (ToBeQueued) {
        queuedPercentage = Math.floor((Queued * 100) / ToBeQueued)
      } else {
        queuedPercentage = 0
      }
      variant = PROGRESSBAR_VARIANT_DEFAULT
    }

    if (State === BERCS_SENDING_STATE_COMPLETED) {
      queueStatus = RCS_QUEUING_COMPLETED
      queuedPercentage = 100
      variant = PROGRESSBAR_VARIANT_SUCCESS

      set(progressState, prev => ({
        ...prev,
        cost: Cost
      }))
      if (Cost > totalCredits) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Rcs.WizardNoCreditToast'
          }),
          TOAST_VARIANT_WARNING,
          'WizardNoCreditToast'
        )
      }
    }

    if (State === BERCS_SENDING_STATE_FALIED) {
      queueStatus = RCS_QUEUING_FAILED
      queuedPercentage = 100
      variant = PROGRESSBAR_VARIANT_ERROR

      toastShow(
        getIntl().formatMessage({
          id: 'Load.Rcs.WizardToastFailedQueueMid'
        }),
        TOAST_VARIANT_ERROR,
        'WizardToastFailedQueueMid'
      )
    }

    set(progressState, prev => ({
      ...prev,
      startQueuing: queueStatus === 'Running',
      queueStatus,
      queued: Queued,
      toBeQueued: ToBeQueued,
      queuedPercentage,
      variant
      // cost: Cost
    }))
  } catch (error) {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Rcs.WizardToastFailedQueueMid'
      }),
      TOAST_VARIANT_ERROR,
      'WizardToastFailedQueueMid'
    )
    logAppError({ appError: error })
    set(progressState, prev => ({
      ...prev,
      queueStatus: 'Failed',
      variant: 'error',
      queued: 0,
      toBeQueued: 0
    }))
  }
}

export const createSendingQueueCallback = ({ snapshot, set }) => async (
  idBot,
  idMessage
) => {
  try {
    set(progressState, prev => ({
      ...prev,
      startQueuing: true,
      queueStatus: RCS_QUEUING_RUNNING,
      queued: 100
    }))
    const {
      includeGroups,
      excludeGroups,
      selectedFilters,
      typeAppliedFilters
    } = await snapshot.getPromise(searchCriteriaState)

    const { recipients } = await snapshot.getPromise(pageState)
    const data = {
      IdAgent: parseInt(idBot),
      Type: recipients === 'filter' ? 'GroupsAndFilters' : 'All'
    }
    if (recipients === 'filter') {
      if (selectedFilters.length > 0) {
        data.FiltersConditionRule = typeAppliedFilters === 'All' ? 'And' : 'Or'
        data.QueueFilter = selectedFilters.map(m => ({ IdFilter: m }))
      }
      if (includeGroups.length > 0 || excludeGroups.length > 0) {
        const included = includeGroups.map(m => ({
          IdGroup: m,
          Action: 'Include'
        }))
        const excluded = excludeGroups.map(m => ({
          IdGroup: m,
          Action: 'Exclude'
        }))
        data.QueueGroup = included.concat(excluded)
      }
    }

    const [sendingQueue, smsCredits] = await Promise.all([
      createSendingQueue(idMessage, data),
      getSmsCredits()
    ])
    set(pageState, prev => ({
      ...prev,
      idQueuing: sendingQueue.IdQueueConf,
      idScheduledSending: sendingQueue.IdScheduledSending,
      totalCredits: smsCredits.TotalCredits,
      backToStep1Disable: true
    }))
  } catch (error) {
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Rcs.WizardToastFailedQueue0'
      }),
      TOAST_VARIANT_ERROR,
      'WizardToastFailedQueue0'
    )
    set(pageState, prev => ({
      ...prev,
      backToStep1Disable: false
    }))

    logAppError({ appError: error })
    set(progressState, prev => ({
      ...prev,
      queueStatus: 'Failed',
      variant: 'error'
    }))
  }
}

export const errorCallback = ({ set }) => async error => {
  logAppError({
    appError: error,
    Component: 'RcsSending',
    Method: 'errorCallback'
  })

  set(pageState, prev => ({
    ...prev,
    error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
    severity: 'danger'
  }))
}

export const sendMessageCallback = ({ set, snapshot }) => async () => {
  let ret = null
  try {
    const { idScheduledSending } = await snapshot.getPromise(pageState)
    const { isScheduledSending } = await snapshot.getPromise(
      scheduledSendingState
    )
    const { momentUtcDate, timeZone } = await snapshot.getPromise(
      contentScheduledState
    )
    const params = {
      Type: isScheduledSending ? 'Scheduled' : 'Immediate'
    }
    if (isScheduledSending) {
      params.ScheduleDate = momentUtcDate.toISOString()
      params.UITimezone = timeZone
    }
    const res = await patchSchedule(idScheduledSending, params)
    if (res.Result === true) {
      ret = true
    } else {
      ret = false
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
  } catch (error) {
    ret = false
    logAppError({ appError: error })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  return ret
}
